/**
 * Util
 */

import UIKIT from 'uikit-utils';
import { from, fromEvent, of } from 'rxjs';
import { map } from 'rxjs/operators';
// import { from } from 'rxjs/observable/from';
// import { fromEvent } from 'rxjs/observable/fromEvent';
// import { map } from 'rxjs/operators/map';

let INSTANCE: Util;

class Util {

	constructor() {

		if ( !INSTANCE ) {
			INSTANCE = this;
		}

		return INSTANCE;
	}

	// public get from() {
	// 	return from;
	// }

	public from(promise: any) {
		const get$ = from( promise );
		return get$.pipe(map((data: any) => {
			const camelCase = new UIKIT.CamelCase();
			return camelCase.convert( data );
		}));
	}

	public get fromEvent() {
		return fromEvent;
	}

	// public get of() {
	// 	return of;
	// }
	//
	// public get map() {
	// 	return map;
	// }
	//
	// public get concat() {
	// 	return concat;
	// }
	//
	// public get scan() {
	// 	return scan;
	// }

	public setDefaultPath( path: string ) {
		return path || '/';
	}

	public get TextAreaAutoHeight() {
		return UIKIT.TextAreaAutoHeight as any;
	}

	public get StringLength() {
		return UIKIT.StringLength as any;
	}

	public get Observer() {
		return UIKIT.Observer as any;
	}

	public get Tmpl() {
		return UIKIT.Template as any;
	}

	public get DataFilter() {
		return UIKIT.DataFilter as any;
	}

	public get getCookie() {
		return UIKIT.Cookie.getCookie;
	}

	public get setCookie() {
		return UIKIT.Cookie.setCookie;
	}

	public get or() {
		return UIKIT.Conditional.or;
	}

	public get and() {
		return UIKIT.Conditional.and;
	}

	public get clone() {
		return UIKIT.ObjectUtil.clone;
	}

	public get cacheDecorator() {
		return UIKIT.ObjectUtil.cacheDecorator;
	}

	public get net() {
		return UIKIT.Net.net;
	}

	public get getStaticUrl() {
		return UIKIT.Net.getStaticUrl;
	}

	public get isLive() {
		return UIKIT.Net.isLive;
	}

	public get diffDate() {
		return UIKIT.DateTime.diffDate;
	}

	public get isDate() {
		return UIKIT.DateTime.isDate;
	}

	public get toISOString() {
		return UIKIT.DateTime.toISOString;
	}

	public get escape() {
		return UIKIT.StringUtil.escape;
	}

	public get escapeTag() {
		return UIKIT.StringUtil.escapeTag;
	}

	public get decode() {
		return UIKIT.StringUtil.decode;
	}

	public get decodeQuot() {
		return UIKIT.StringUtil.decodeQuot;
	}

	public get decodeAll() {
		return UIKIT.StringUtil.decodeAll;
	}

	public get replaceBr() {
		return UIKIT.StringUtil.replaceBr;
	}

	public get pad() {
		return UIKIT.StringUtil.fillZero;
	}

	public get get() {
		return UIKIT.Load.get;
	}

	public get getAll() {
		return UIKIT.Load.getAll;
	}

	public get getAllPromise() {
		return UIKIT.Load.getAllPromise;
	}

	public getJsonp( url: string, method: string, data?: any ) {
		return UIKIT.Load.getJsonp( url, method, data );
	}

	public get loadFile() {
		return UIKIT.Load.loadFile;
	}

	public get replaceUploadImage() {
		return UIKIT.Image.replaceUploadImage;
	}

	public dateFormat( dateInfo: any ) {
		return new UIKIT.DateFormat( dateInfo.now, {
			a_few_seconds_ago: dateInfo.L10N.a_few_seconds_ago,
			seconds_ago: dateInfo.L10N.seconds_ago,
			a_minute_ago: dateInfo.L10N.a_minute_ago,
			minutes_ago: dateInfo.L10N.minutes_ago,
			an_hour_ago: dateInfo.L10N.an_hour_ago,
			hours_ago: dateInfo.L10N.hours_ago,
			a_day_ago: dateInfo.L10N.a_day_ago,
			days_ago: dateInfo.L10N.days_ago,
			a_month_ago: dateInfo.L10N.a_month_ago,
			months_ago: dateInfo.L10N.months_ago,
			a_year_ago: dateInfo.L10N.a_year_ago,
			years_ago: dateInfo.L10N.years_ago,
		}, true);
	}

	public convertCamelCase( obj: any ) {
		const camelCase = new UIKIT.CamelCase();
		return camelCase.convert( obj );
	}

	public getParams() {
		return UIKIT.Url.getParams();
	}

	public hashs( url: string ) {
		return UIKIT.Url.hashs( url );
	}

	public getHash() {
		return UIKIT.Url.getHash();
	}

	public replaceImage( content: string ) {
		return UIKIT.StringUtil.replaceImage( content );
	}

	public replaceEmoticon( content: string ) {
		return UIKIT.StringUtil.replaceImage( content );
	}

	public setWrapLink( url: string, text: string ) {
		return UIKIT.StringUtil.setWrapLink( url, text );
	}

	public setWrapImage( src: string ) {
		return UIKIT.StringUtil.setWrapImage( src );
	}

	public setDefaultByEmptyString( data: any ) {
		return UIKIT.StringUtil.setDefaultByEmptyString( data );
	}

	// public confirm( msg: any, resolve: any, reject: any ) {
	// 	(UIKIT.Site as any).confirm( msg, resolve, reject );
	// }

	public isUrl( url: string ) {
		return /(http|https)\:\/\//.test( url );
	}
}

export default new Util() as any;
